module.exports = __webpack_public_path__ + "img/facebook.48f1341e.svg";